import {
	SET_PREFERENCES,
	SET_PREFERENCE,
	CLEAR_PREFERENCES,
	CLEAR_PREFERENCE,
	ADD_PREFERENCE,
	UPDATE_PREFERENCE,
	REMOVE_PREFERENCE,
} from './actionTypes';

export const preference = (state = {}, action) => {
	switch (action.type) {
		case SET_PREFERENCE:
			return action.payload;
		case UPDATE_PREFERENCE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_PREFERENCE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_PREFERENCES:
			return action.payload;
		case ADD_PREFERENCE:
			return [...state, action.payload];
		case UPDATE_PREFERENCE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_PREFERENCE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_PREFERENCES:
			return [];
		default:
			return state;
	}
};
